import { render } from "./SubteamsView.vue?vue&type=template&id=4caaac2e"
import script from "./SubteamsView.vue?vue&type=script&lang=js"
export * from "./SubteamsView.vue?vue&type=script&lang=js"

import "./SubteamsView.vue?vue&type=style&index=0&id=4caaac2e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__